import { FokParameterChoice } from '@fora-monorepo/employer-my-pages-common/types';
import { isPensionParameter } from '@fora-monorepo/employer-my-pages-common/utils';
import { DateRangeItemDetails } from '@foradevelopment/fora-ui';

import { DittoKeys, useTypedTranslation } from '../../i18n/i18n';

export const ParameterChoiceDateRangeItemDetail = ({
  name,
  description,
  fokParameterChoice,
  showHeading,
}: {
  name: DittoKeys;
  description: DittoKeys;
  fokParameterChoice: FokParameterChoice;
  showHeading: boolean;
}) => {
  const { t } = useTypedTranslation();

  return (
    <DateRangeItemDetails
      headingComponent="H5"
      subTitleComponent="H6"
      title={showHeading ? t('list.markupAndParametersList.parameterTitle') : ''}
      subTitle={t(name)}
      description={isPensionParameter(fokParameterChoice.parameterValue) ? t(description) : undefined}
      startDate={isPensionParameter(fokParameterChoice.parameterValue) ? undefined : fokParameterChoice.startDate}
      endDate={fokParameterChoice.endDate}
    />
  );
};
